        
<!-- ============================================================== -->
<!-- Profile - style you can find in header.scss -->
<!-- ============================================================== -->
<button [matMenuTriggerFor]="profile" mat-icon-button class="m-r-5"> 
    <!-- <img *ngIf="imageUrl" [src]="imageUrl" alt="user" class="profile-pic"> 
    <img *ngIf="!imageUrl" src="assets/images/user_avatar_full.svg" alt="user" class="profile-pic">  -->
</button>
<mat-menu #profile="matMenu" class="mymegamenu">
    <!-- <button mat-menu-item><mat-icon>settings</mat-icon> Settings </button>-->
    <a mat-menu-item [routerLink]="[ '/users/edit', userId ]">
        <mat-icon>account_box</mat-icon> {{ 'PROFILE' | translate }} 
    </a>
    <!-- <button mat-menu-item><mat-icon>notifications_off</mat-icon> Disable notifications </button> -->
    <button mat-menu-item (click)="authService.logout()">
        <mat-icon>exit_to_app</mat-icon> {{ 'LOGOUT' | translate }} 
    </button>
</mat-menu>

